"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let OrderDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.app_name = "";
    this.product_name = "";
    this.order_no = "";
    this.order_type = "";
    this.status = "";
    this.operator = "";
    this.order_create_time = 0;
    this.pay_platform = "";
    this.duration = "";
    this.num = "";
    this.original_price = "";
    this.favorable_price = "";
    this.discount_coupon = "";
    this.should_pay_coin = "";
    this.should_pay_price = "";
    this.invoice = "";
    this.no = "";
    this.type = "";
    this.created_time = "";
    this.coin_count = "";
    this.vd_count = "";
    this.coins = "";
    this.pay_money = "";
    this.traffic = 0;
    this.vd_name = "";
  }
};
OrderDetailModel.model = "order.get";
OrderDetailModel = __decorateClass([
  Annotation.ModelMeta
], OrderDetailModel);
export let OrderModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.coins = 0;
    this.created_time = "";
    this.discount_coupon = "";
    this.duration = "";
    this.environment_setting = "";
    this.favorable_price = 0;
    this.id = "";
    this.invoice = "";
    this.ip_setting = "";
    this.no = "";
    this.operator = "";
    this.original_price = 0;
    this.pay_money = 0;
    this.pay_platform = "";
    this.status = "";
    this.type = "";
    this.vd_count = 0;
  }
};
OrderModel.model = "vd.new.order.detail";
OrderModel = __decorateClass([
  Annotation.ModelMeta
], OrderModel);
export let AppNumberModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.account_id = "";
    this.app_name = "";
    this.discount_code = "";
    this.duration = "";
    this.favorable_price = 0;
    this.must_pay = false;
    this.num = 0;
    this.operator_id = "";
    this.order_create_time = 0;
    this.order_no = "";
    this.order_type = "";
    this.org_id = "";
    this.original_price = 0;
    this.pay_platform = "";
    this.product_name = "";
    this.should_pay_coin = 0;
    this.should_pay_price = 0;
  }
};
AppNumberModel.model = "cloudPhone.order.detail";
AppNumberModel = __decorateClass([
  Annotation.ModelMeta
], AppNumberModel);
